// extracted by mini-css-extract-plugin
module.exports = {"collect":"index_collect__2m_OQ","text":"index_text__3Zsu4","img":"index_img__3MocK","btn":"index_btn__1lu7Q"};